import { UIText2, TooltipDesktop } from '@cian/ui-kit';
import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { Error, Loading, KeyValTable } from '../commonComponents';
import { INearbyHousesInfoData } from '../../../../containers/OfferHistory/types';

export interface INearbyHousesInfoProps {
  nearbyHousesInfoData: INearbyHousesInfoData | null;
  isError?: boolean;
  isLoading?: boolean;
  onMouseEnter(): void;
}

export const NearbyHousesInfo: React.VFC<INearbyHousesInfoProps> = props => {
  const { nearbyHousesInfoData, isError, isLoading, onMouseEnter } = props;

  return (
    <TooltipDesktop
      theme="white"
      placement="bottom-start"
      title={
        <div className={styles['content']} data-testid="nearby_house_info_content">
          {isError && <Error />}
          {isLoading && <Loading height={180} />}
          {nearbyHousesInfoData && (
            <>
              <UIText2>
                Соседними называем максимально похожие дома, расположенные поблизости. Эти дома удовлетворяют критериям:
              </UIText2>
              <KeyValTable className={styles['features']} table={nearbyHousesInfoData.features} />
            </>
          )}
        </div>
      }
    >
      <div className={styles['button']} onMouseEnter={onMouseEnter}>
        <IconFunctionalInformation16 color="icon-main-default" display="block" />
        <UIText2 color="text-main-default">Как определяем соседние дома</UIText2>
      </div>
    </TooltipDesktop>
  );
};
